<template>
     <b-row>
        <b-col>
            <information-overview-tab v-if="hasResults" mode="details" class="accessible" />
        </b-col>
    </b-row>
</template>

<script>
    import InformationOverviewTab from '../information';

    export default {
        components: { 'information-overview-tab': InformationOverviewTab },
        computed: {
            hasResults() {
                return this.$store.state.selections.length > 0;
            }
        }
    };
</script>
